import { useForm } from "react-hook-form";
import { FORM_FIELDS } from "../../Constants";
import React, { useEffect, useState } from "react";
import Tooltip from "../../../Common/Tooltip";
import Stepper from "../../components/Stepper";
import ErrorMessage from "../../components/ErrorMessage";

const CertificateData = ({ stepState, previousPage, nextPage, formData }) => {
  const { CERTIFICATE_DATA } = FORM_FIELDS;

  const inputFile = React.useRef(null);

  const [, setRerender] = useState(false);

  const { register, handleSubmit, errors, getValues, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      ...formData[CERTIFICATE_DATA.name],
      [CERTIFICATE_DATA.FILE_CONTENT.name]:
        formData[CERTIFICATE_DATA.name]?.[CERTIFICATE_DATA.FILE_CONTENT.name]
          ?.length > 0
          ? formData[CERTIFICATE_DATA.name][CERTIFICATE_DATA.FILE_CONTENT.name]
          : undefined,
    },
  });

  useEffect(() => {
    // if component is not rerendered on initial load selectedFile var will be undefined while returning form step
    setRerender((x) => !x);
  }, []);

  const onNextPage = (data) => {
    nextPage({
      [CERTIFICATE_DATA.name]: data,
    });
  };

  const handleOnDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    const fileList = new DataTransfer();
    files.forEach((file) => {
      fileList.items.add(file);
    });
    setValue(CERTIFICATE_DATA.FILE_CONTENT.name, fileList.files);
  };

  const checkIsP12 = (uploadedFile) => {
    if (!uploadedFile) return true;
    if (uploadedFile.type === "application/x-pkcs12") {
      return true;
    }

    return false;
  };

  const selectedFile = document.getElementsByName(
    CERTIFICATE_DATA.FILE_CONTENT.name
  )[0]?.files[0];

  const IS_REQUIRED = getValues(CERTIFICATE_DATA.FILE_CONTENT.name)?.length > 0;

  return (
    <>
      <div className="row">
        <div className="col-lg-6">
          <h1 className="my-4 text-center">Fina certifikat</h1>
          <p>
            Upute za preuzimanje FINA certifikata preuzmite{" "}
            <a href="https://www.fina.hr/ngsite/content/download/9548/170545/1">
              ovdje
            </a>
            .
          </p>
          <ul>
            <li>
              Nakon zatraženog FINA certifikata, zaprimit će aktivacijski kod
              SMS-om, a referentni broj e-mailom
            </li>
            <li>
              Kada zaprimite podatke potrebno je otići na stranicu
              https://mojcert.fina.hr/finacms/
            </li>
            <li>
              Nakon što se otvori stranica za preuzimanje certifikata, potrebno
              je odabrati tipku „ Registriraj se“ te zatim „Preuzimanje soft
              certifikata“{" "}
            </li>
            <li>
              Potrebno je upisati referentni broj i aktivacijski kod. Nakon
              upisa kliknuti ''Registriraj se''
            </li>
            <li>
              Otvara se prozor sa svim podacima tvrtke. Potrebno je označiti
              certifikat i kliknuti ''Izdaj označeno'' na desnoj strani ekrana
            </li>
            <li>
              Nakon toga otvara se prozor za postavljanje ''Lozinke za P12
              datoteku''
            </li>
            <li>
              Potrebno je definirati lozinku po pravilima koja su raspisana na
              tom prozoru (i lozinku spremiti) – jer se više ne može mijenjati
            </li>
            <li>
              Nakon toga se ponudi ''Preuzmi certifikat'' i lokalno se sprema na
              računalo
            </li>
            <li>
              Datoteka se ne može otvoriti već ju je potrebno takvu uploadati na
              portal usluge
            </li>
          </ul>
          <p>
            {" "}
            Upute za učitavanje i upisivanje lozinke u Premium fiskalnu blagajnu
            nalaze se{" "}
            <a href="https://digitalno-poslovanje.hrvatskitelekom.hr/Business/PFB%20-%20Obnova%20i%20upload%20FINA%20certifikata.docx">
              ovdje
            </a>
            .
          </p>
          <hr></hr>
          Ako nemate FINA certifikat nastavite s popunjavanjem podataka,a
          certifikat i lozinku dostavite naknadno na e-mail adresu:
          <a href="mailto: korisnik.pfb@t.ht.hr">korisnik.pfb@t.ht.hr</a>. Molimo u mailu navesti Oib i Naziv pravnog
          subjekta.
          <p></p>
          <p></p>
        </div>
        <div className="col-lg-6">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {CERTIFICATE_DATA.CERT_PASSWORD.title}
            </legend>
            <div className="form-group">
              <label> {CERTIFICATE_DATA.FILE_CONTENT.title}</label>{" "}
              <div
                className="csv-import-container"
                onDrop={handleOnDrop}
                onDragOver={(e) => e.preventDefault()}
              >
                Povucite datoteku u ovo polje ili <br />
                <button
                  className="btn btn-primary"
                  onClick={() => inputFile.current.click()}
                >
                  Odaberite datoteku
                </button>
                <input
                  style={{ display: "none" }}
                  type="file"
                  className="form-control-file"
                  name={CERTIFICATE_DATA.FILE_CONTENT.name}
                  onChange={() => {
                    setRerender((x) => !x);
                  }}
                  ref={(input) => {
                    register(input, {
                      validate: () =>
                        checkIsP12(
                          document.getElementsByName(
                            CERTIFICATE_DATA.FILE_CONTENT.name
                          )[0]?.files[0]
                        ),
                    });
                    inputFile.current = input;
                  }}
                />
                <div>{selectedFile?.name}</div>
              </div>
              <ErrorMessage
                errorType={errors?.[CERTIFICATE_DATA.FILE_CONTENT.name]?.type}
                messages={{
                  validate: "Certifikat mora biti u P12 formatu.",
                }}
              />
            </div>
            <div className="form-group">
              <label>{"Lozinka"}</label>{" "}
              <Tooltip
                text={
                  "Upišite lozinku koju ste kreirali za P12 datoteku. Lozinka nam je potrebna kako bismo mogli upisati certifikat na blagajnu."
                }
              />
              <input
                type="text"
                className="form-control"
                name={CERTIFICATE_DATA.CERT_PASSWORD.name}
                ref={register({
                  required: IS_REQUIRED,
                  maxLength: 50,
                })}
              />
              <ErrorMessage
                errorType={errors?.[CERTIFICATE_DATA.CERT_PASSWORD.name]?.type}
                messages={{
                  required: "Ovo polje je obavezno.",
                  maxLength: "Moguće je unijeti maksimalno 50 znakova!",
                }}
              />
            </div>
          </fieldset>
        </div>
      </div>
      <Stepper
        stepState={stepState}
        previousPage={previousPage}
        nextPage={handleSubmit(onNextPage)}
      />
    </>
  );
};

export default CertificateData;
